import React from 'react';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import Grid from "@mui/material/Grid2";
import { Link } from 'react-router-dom';
import { Facebook, Linkedin } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#2A3990', color: 'white', py: 2, mt: 'auto' }}>
      <Container maxWidth="lg" >
        <Grid container spacing={4} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
          {/* Logo and School Info */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
              <Box
                component="img"
                src="images/logo-bka.png"
                alt="Logo"
                sx={{ height: 60, mr: 2, mb: { xs: 1, md: 2 } }}
              />
              <Box display='flex' flexDirection='column' alignItems='center'>
                <Typography variant="h6" sx={{ color: '#64B5F6', mb: 1 }}>
                  BACH KHOA ALUMNI - BKA
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                  TRƯỜNG ĐẠI HỌC BÁCH KHOA - ĐẠI HỌC QUỐC GIA TP.HCM
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              268 Lý Thường Kiệt, Phường 14, Quận 10, TP.HCM
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Email: bka@hcmut.edu.vn
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Quỹ hoạt động theo Quyết định 4251/QĐ-UBND của Uỷ ban Nhân dân Thành phố Hồ Chí Minh
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid size={{ xs: 6, md: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }} fontWeight={500}>
              Liên kết
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <MuiLink component={Link} to="/" color="inherit" underline="hover">Trang chủ</MuiLink>
              <MuiLink component={Link} to="/dong-gop-ca-nhan" color="inherit" underline="hover">Đóng góp cá nhân</MuiLink>
              <MuiLink component={Link} to="/dong-gop-doanh-nghiep" color="inherit" underline="hover" sx={{ whiteSpace: 'nowrap' }}>Đóng góp doanh nghiệp</MuiLink>
              <MuiLink component={Link} to="/lien-he" color="inherit" underline="hover">Liên hệ</MuiLink>
            </Box>
          </Grid>

          {/* Mobile App */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              KẾT NỐI VỚI CHÚNG TÔI
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <MuiLink href="https://www.facebook.com/bachkhoaalumni" target="_blank" rel="noopener" sx={{ color: 'white' }}>
                <Facebook size={24} />
              </MuiLink>
              <MuiLink href="hhttps://www.linkedin.com/company/hcmut/?viewAsMember=true" target="_blank" rel="noopener" sx={{ color: 'white' }}>
                <Linkedin size={24} />
              </MuiLink>
            </Box>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 4, textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.1)', pt: 2 }}>
          Copyright © 2025 Quỹ Bảo Lãnh Sinh Viên Vay Lãi Suất 0%
        </Typography>
      </Container>
    </Box >
  );
};

export default Footer;